import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors, colorConstants } from 'theme/default'

const ProgressContainer = styled.div`
  position: relative;
  height: 6px;
  width: 100%;
  border-radius: 9999px;
  background-color: ${colorConstants.lightGray};
`
ProgressContainer.propTypes = {
  background: PropTypes.string
}
ProgressContainer.defaultProps = {
  theme: {
    colorBackgroundColor: colors.background
  }
}

const Progress = styled.div`
  transition: width 0.5s ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  height: 6px;
  border-radius: 9999px;
  width: ${props => `${props.percent}%`};
  background-color: ${props => props.fill || (Math.round(props.percent, 0) === 100 ? colorConstants.green : colorConstants.yellow)};
`

Progress.propTypes = {
  percent: PropTypes.number,
  fill: PropTypes.string
}

class ProgressBar extends React.PureComponent {
  static propTypes = {
    ...Progress.propTypes,
    ...ProgressContainer.propTypes
  }

  render () {
    const { percent: _percent, fill, background } = this.props
    const percent = Math.min(_percent, 100)
    return (
      <ProgressContainer background={background}>
        <Progress percent={percent} fill={fill} />
      </ProgressContainer>
    )
  }
}

export default ProgressBar
